export default "__VITE_ASSET__5ac0d7cf__"